window.LoopTranslations = {
  PT: {
    // Dogs section
    dogs: {
      yourDogs: "Os meus cães",
      addNewDog: "Adicionar novo cão",
      name: "Nome",
      gender: "Género",
      lifeStage: "Fase da vida",
      weight: "Peso",
      male: "Macho",
      female: "Fêmea",
      puppy: "Cachorro",
      adult: "Adulto",
      senior: "Sénior",
      save: "Guardar",
      deleteProfile: "Apagar Perfil",
      cancel: "Cancelar",
      editDog: "Editar cão",
      deleteDogConfirmation: "Tem a certeza que quer apagar este perfil?",
      deleteDogWarning: "Depois de apagar, não poderá recuperar o perfil.",
      deleteDogNote:
        "Apagar o perfil do seu cão não elimina o plano. Para isso, clique no botão lateral 'Gerir encomendas'",
      thisPlanIsFor: "Este plano é para:",
      enterDogName: "Inserir nome do cão",
      enterDogWeight: "Inserir peso do cão",
      forDogs: "Para %s",
      articleMale: "o",
      articleFemale: "a",
      nameSeparator: "e",
      saveError: "Não foi possível guardar. Tente novamente.",
      loadError: "Não foi possível carregar os seus cães.",
      noDogs: "Ainda não tem cães adicionados.",
      requiredFields: "Preencha: %s.",
      sessionExpired: "A sua sessão expirou. Volte a iniciar sessão.",
      duplicateName: "Já tem um cão com este nome. Escolha outro nome.",
    },

    // UI elements
    ui: {
      see: "Ver",
      close: "Fechar",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      delete: "Apagar",
      confirm: "Confirmar",
      loading: "A carregar...",
      retry: "Tentar novamente",
      error: "Erro",
      success: "Sucesso",
      update: "Atualizar",
      seeMore: "Ver mais",
    },

    // Wallet section
    wallet: {
      title: "Wallet",
      knowMore: "Saber mais",
      close: "Fechar",
      earnCredit: "Ganhe crédito em cada encomenda:",
      earnCreditDesc: "Ganhe crédito a cada encomenda e troque-o por produtos.",
      expiry: "Expiração:",
      expiryDesc: "O crédito expira após 45 dias sem encomendas.",
      expiresIn: "Expira em %d dias",
      expiresInOne: "Expira em 1 dia",
      expiresInToday: "Expira hoje",
      expired: "Expirado",
      addProductWithWallet: "Adicionar produto com Wallet",
      productAddedSuccess: "Produto adicionado com sucesso!",
      productAddedError: "Erro ao adicionar produto. Tente novamente.",
      insufficientBalance: "Saldo insuficiente na Wallet",
      addProductSuccess: "Produto adicionado à próxima encomenda",
      youHaveCredit: "Tem %s€",
      notEnoughCredit: "Não tem crédito suficiente. Tem %s€",
      cantUseForSubscriptions: "Não pode usar crédito para subscrições",
      reactivateToUseWallet:
        "Reativar subscrição para usar o crédito da Wallet",
      reactivateDesc:
        "Depois de reativar poderá trocar o seu crédito por produtos.",
    },

    // Orders & Subscription
    orders: {
      deliveredEveryMonth: "· Entregue todos os meses",
      lastOrderCharged: "A última encomenda foi cobrada em %s",
      quantity: "Quantidade: %d",
      processingInfo:
        "Estamos a processar a sua encomenda. O estado será atualizado automaticamente dentro de instantes.",
      processingDelayed:
        "O processamento da sua encomenda está a demorar mais tempo do que o habitual. Consulte o estado da encomenda mais tarde.",
    },

    shipping: {
      shippingCost: "%s€ entrega",
      freeShipping: "· Entrega gratuita",
    },

    // User actions
    user: {
      logout: "Encerrar sessão",
      login: "Iniciar sessão",
      profile: "Perfil",
      account: "Conta",
      subscription: "Subscrição",
      subscriptionCancelled: "O seu plano está cancelado",
      subscriptionTitle: "Subscrição de",
      reactivate: "Reativar",
      reactivateAndOrderNow: "Reativar e encomendar agora",
      reactivateConfirm:
        "Ao clicar no botão “OK”, irá reativar o seu plano e processaremos a sua encomenda.",
      subscriptionCancelledDesc:
        "Clique em “<strong>Reativar</strong>” para alterar ou remover produtos do seu plano. <br> Se pretende receber o seu plano agora, tal como está, clique em “<strong>Reativar e encomendar agora</strong>”.",
      editProduct: "Editar produto",
      removeProduct: "Remover",
      addedWithWallet: "Adicionado com wallet",
      confirmDelete:
        "Tem a certeza que deseja remover este produto do seu plano?",
      cannotRemoveLastProduct:
        "Este é o único produto da subscrição, por isso não pode ser removido.",
    },

    errors: {
      generic: "Ocorreu um erro. Por favor, tente novamente.",
      paymentError: {
        title: "Não foi possível processar o seu pagamento",
        description:
          "Atualize o método de pagamento para concluir a encomenda.\nSe estiver a usar um cartão de compra única, tente em alternativa um cartão de pagamento recorrente.",
        cta: "Atualizar método de pagamento",
      },
    },
  },

  IT: {
    // Dogs section
    dogs: {
      yourDogs: "I miei cani",
      addNewDog: "Aggiungi nuovo cane",
      name: "Nome",
      gender: "Sesso",
      lifeStage: "Fase della vita",
      weight: "Peso",
      male: "Maschio",
      female: "Femmina",
      puppy: "Cucciolo",
      adult: "Adulto",
      senior: "Senior",
      save: "Salva",
      deleteProfile: "Elimina Profilo",
      cancel: "Annulla",
      editDog: "Modifica cane",
      deleteDogConfirmation: "Sei sicuro di voler eliminare questo profilo?",
      deleteDogWarning:
        "Dopo l'eliminazione, non potrai recuperare il profilo.",
      deleteDogNote:
        "Eliminare il profilo del tuo cane non elimina il piano. Per farlo, clicca sul pulsante laterale 'Gestisci ordini'",
      thisPlanIsFor: "Questo piano è per:",
      enterDogName: "Inserisci nome del cane",
      enterDogWeight: "Inserisci peso del cane",
      forDogs: "Per %s",
      articleMale: "",
      articleFemale: "",
      nameSeparator: "e",
      saveError: "Non è stato possibile salvare. Riprova.",
      loadError: "Non è stato possibile caricare i tuoi cani.",
      noDogs: "Non hai ancora aggiunto cani.",
      requiredFields: "Compila: %s.",
      sessionExpired: "La tua sessione è scaduta. Accedi di nuovo.",
      duplicateName: "Hai già un cane con questo nome. Scegli un altro nome.",
    },

    // UI elements
    ui: {
      see: "Vedi",
      close: "Chiudi",
      cancel: "Annulla",
      save: "Salva",
      edit: "Modifica",
      delete: "Elimina",
      confirm: "Conferma",
      loading: "Caricamento...",
      retry: "Riprova",
      error: "Errore",
      success: "Successo",
      update: "Aggiorna",
      seeMore: "Vedi di più",
    },

    // Wallet section
    wallet: {
      title: "Wallet",
      knowMore: "Scopri di più",
      close: "Chiudi",
      earnCredit: "Guadagna credito ad ogni ordine:",
      earnCreditDesc:
        "Guadagna credito con ogni ordine e riscattalo per i prodotti.",
      expiry: "Scadenza:",
      expiryDesc: "Il credito scade dopo 60 giorni senza ordini.",
      expiresIn: "Credito scade tra %d giorni",
      expiresInOne: "Credito scade tra 1 giorno",
      expiresInToday: "Il credito scade oggi",
      expired: "Scaduto",
      addProductWithWallet: "Usa il credito del Wallet",
      productAddedSuccess: "Prodotto aggiunto con successo!",
      productAddedError: "Errore nell'aggiunta del prodotto. Riprova.",
      insufficientBalance: "Saldo insufficiente nel Wallet",
      addProductSuccess: "Prodotto aggiunto al prossimo ordine",
      youHaveCredit: "Hai %s€ nel wallet",
      notEnoughCredit: "Non hai abbastanza credito. Hai %s€ nel wallet",
      cantUseForSubscriptions: "Non puoi usare il credito per gli abbonamenti",
      reactivateToUseWallet:
        "Riattiva l'abbonamento per usare il credito della Wallet",
      reactivateDesc:
        "Dopo la riattivazione potrai scambiare il tuo credito con prodotti.",
    },

    // Orders & Subscription
    orders: {
      deliveredEveryMonth: "· Consegnato ogni mese",
      lastOrderCharged: "L'ultimo ordine è stato addebitato il %s",
      quantity: "Quantità: %d",
      processingInfo:
        "Stiamo elaborando il tuo ordine. Lo stato si aggiornerà automaticamente tra pochi istanti.",
      processingDelayed:
        "L'elaborazione del tuo ordine sta richiedendo più tempo del solito. Controlla lo stato dell'ordine più tardi.",
      // WEB-152: order history drawer (pending Sofia approval)
      downloadInvoice: "Scarica la fattura",
      invoiceNotAvailable: "La fattura di questo ordine non è ancora disponibile.",
      invoiceError: "Non è stato possibile scaricare la fattura. Riprova più tardi.",
    },

    shipping: {
      shippingCost: "%s€ spedizione",
      freeShipping: "· Spedizione gratuita",
    },

    // User actions
    user: {
      logout: "Esci",
      login: "Accedi",
      profile: "Profilo",
      account: "Account",
      subscription: "Abbonamento",
      subscriptionCancelled: "Il tuo piano è stato annullato",
      subscriptionTitle: "Abbonamento di",
      reactivate: "Riattiva",
      reactivateAndOrderNow: "Riattiva e ordina ora",
      reactivateConfirm:
        "Cliccando su “OK”, riattiverai il tuo piano e processeremo il tuo ordine.",
      subscriptionCancelledDesc:
        "Fai clic su “<strong>Riattiva</strong>” per modificare o rimuovere prodotti dal tuo piano. <br> Se vuoi ricevere il tuo piano così com’è e ordinare subito, fai clic su “<strong>Riattiva e ordina ora</strong>”.",
      editProduct: "Modifica prodotto",
      removeProduct: "Rimuovi",
      addedWithWallet: "Aggiunto con wallet",
      confirmDelete:
        "Sei sicuro di voler rimuovere questo prodotto dal tuo piano?",
      cannotRemoveLastProduct:
        "Questo è l'unico prodotto dell'abbonamento, per cui non può essere rimosso.",
    },

    errors: {
      generic: "Si è verificato un errore. Riprova.",
      paymentError: {
        title: "Non siamo riusciti a elaborare il tuo pagamento",
        description:
          "Aggiorna il metodo di pagamento per completare il tuo ordine.\nSe stai utilizzando una carta per pagamenti una tantum, prova con una carta che supporti pagamenti ricorrenti.",
        cta: "Aggiorna metodo di pagamento",
        retry: "Riprova",
        byCategory: {
          CARD_EXPIRED: {
            title: "La tua carta è scaduta",
            description: "Aggiorna la tua carta per completare il tuo ordine.",
          },
          INCORRECT_CARD_NUMBER: {
            title: "Il numero della tua carta non è valido",
            description: "Verifica i dati della tua carta e riprova.",
          },
          INSUFFICIENT_FUNDS: {
            title: "La carta non ha fondi sufficienti",
            description: "Per completare il tuo ordine, aggiorna la tua carta.",
          },
          INVALID_PAYMENT_METHOD: {
            title: "Il metodo di pagamento non è valido",
            description:
              "Aggiungi una nuova carta per continuare. Se stai usando una carta usa e getta, prova con una carta per pagamenti ricorrenti.",
          },
          CARD_TYPE_NOT_SUPPORTED: {
            title: "Questa carta non supporta i pagamenti ricorrenti",
            description:
              "Succede solitamente con carte usa e getta (temporanee o virtuali). Prova con una carta fisica o, se ti serve una carta temporanea, scegline una che permetta pagamenti ricorrenti.",
          },
          PAYMENT_METHOD_REVOKED: {
            title: "Il tuo metodo di pagamento è stato rimosso",
            description:
              "Aggiungi un nuovo metodo di pagamento per continuare. Se stai usando una carta usa e getta, prova con una carta per pagamenti ricorrenti.",
          },
          FRAUD_SUSPECTED: {
            title: "Non è stato possibile confermare questo pagamento",
            description:
              "Prova un altro metodo di pagamento.",
          },
          INVALID_ADDRESS: {
            title: "L'indirizzo di fatturazione non corrisponde alla tua carta",
            description: "Verifica l'indirizzo e riprova.",
          },
          AUTHENTICATION_FAILED: {
            title: "Non è stato possibile confermare l'autenticazione del pagamento",
            description: "Riprova o usa un altro metodo di pagamento.",
          },
          PAYPAL_AGREEMENT_CANCELLED: {
            title: "Il tuo accordo con PayPal è stato annullato",
            description: "Ricollega PayPal o aggiungi un altro metodo di pagamento.",
          },
          PAYPAL_AGREEMENT_INVALID: {
            title: "Il tuo accordo con PayPal non è valido",
            description: "Ricollega PayPal o aggiungi un altro metodo di pagamento.",
          },
          PAYPAL_GENERAL_ERROR: {
            title: "Si è verificato un errore con PayPal",
            description: "Riprova o usa un altro metodo di pagamento.",
          },
          INVALID_CUSTOMER: {
            title: "Non è stato possibile convalidare i tuoi dati",
            description: "Contatta il nostro supporto.",
          },
          GENERIC_ERROR: {
            title: "Non è stato possibile elaborare il tuo pagamento",
            description:
              "Aggiorna la tua carta oppure provane un'altra per consentirci di elaborare il tuo ordine. Se stai usando una carta usa e getta, prova con una carta per pagamenti ricorrenti.",
          },
          INVALID_GIFT_CARD_AMOUNT: {
            title: "Il valore della carta regalo non è valido",
            description: "Usa un altro metodo di pagamento.",
          },
          INSUFFICIENT_INVENTORY: {
            title: "Non c'è abbastanza stock per l'ordine",
            description: "Rimuovi il prodotto esaurito per completare l'ordine.",
          },
          NO_INVENTORY_LOCATION: {
            title: "Non è stato possibile localizzare lo stock per questo ordine.",
            description: "Contatta il nostro supporto.",
          },
          INVALID_CURRENCY: {
            title: "Si è verificato un errore con la valuta del pagamento.",
            description: "Contatta il nostro supporto per risolvere questa situazione.",
          },
          INVOICE_ALREADY_PAID: {
            title: "Quest'ordine è già stato pagato",
            description: "Non è necessaria alcuna azione da parte tua.",
          },
          MERCHANT_ACCOUNT_ERROR: {
            title: "Si è verificato un errore nell'elaborazione del pagamento",
            description: "Contatta il nostro supporto per risolvere questa situazione.",
          },
          GATEWAY_TEST_MODE_ERROR: {
            title: "Si è verificato un errore nell'elaborazione del pagamento",
            description: "Contatta il nostro supporto per risolvere questa situazione.",
          },
          PAYMENT_PROVIDER_ERROR: {
            title: "Si è verificato un errore nell'elaborazione del pagamento",
            description: "Riprova tra qualche secondo.",
          },
          PAYMENT_PROVIDER_NOT_ENABLED: {
            title: "Questo metodo di pagamento non è disponibile",
            description: "Usa un altro metodo di pagamento.",
          },
          TRANSACTION_LIMIT_EXCEEDED: {
            title: "Non è stato possibile confermare questo pagamento",
            description:
              "Aggiungi una nuova carta per continuare. Se stai usando una carta usa e getta, prova con una carta per pagamenti ricorrenti.",
          },
          TRANSIENT_ERROR: {
            title: "Si è verificato un errore temporaneo durante l'elaborazione del pagamento",
            description: "Riprova tra qualche secondo.",
          },
          AMOUNT_OUT_OF_RANGE: {
            title: "L'importo della transazione non è valido",
            description: "Contatta il nostro supporto.",
          },
        },
      },
    },
  },

  ES: {
    // Dogs section
    dogs: {
      yourDogs: "Mis perros",
      addNewDog: "Añadir nuevo perro",
      name: "Nombre",
      gender: "Género",
      lifeStage: "Etapa de vida",
      weight: "Peso",
      male: "Macho",
      female: "Hembra",
      puppy: "Cachorro",
      adult: "Adulto",
      senior: "Senior",
      save: "Guardar",
      deleteProfile: "Eliminar Perfil",
      cancel: "Cancelar",
      editDog: "Editar perro",
      deleteDogConfirmation:
        "¿Estás seguro de que quieres eliminar este perfil?",
      deleteDogWarning: "Después de eliminar, no podrás recuperar el perfil.",
      deleteDogNote:
        "Eliminar el perfil de tu perro no elimina el plan. Para eso, haz clic en el botón lateral 'Gestionar pedidos'",
      thisPlanIsFor: "Este plan es para:",
      enterDogName: "Introducir nombre del perro",
      enterDogWeight: "Introducir peso del perro",
      forDogs: "Para %s",
      articleMale: "",
      articleFemale: "",
      nameSeparator: "y",
      saveError: "No se ha podido guardar. Inténtalo de nuevo.",
      loadError: "No se han podido cargar tus perros.",
      noDogs: "Aún no tienes perros añadidos.",
      requiredFields: "Rellena: %s.",
      sessionExpired: "Tu sesión ha caducado. Vuelve a iniciar sesión.",
      duplicateName: "Ya tienes un perro con este nombre. Elige otro nombre.",
    },

    // UI elements
    ui: {
      see: "Ver",
      close: "Cerrar",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      delete: "Eliminar",
      confirm: "Confirmar",
      loading: "Cargando...",
      retry: "Intentar de nuevo",
      error: "Error",
      success: "Éxito",
      update: "Actualizar",
      seeMore: "Ver más",
    },

    // Wallet section
    wallet: {
      title: "Wallet",
      knowMore: "Saber más",
      close: "Cerrar",
      earnCredit: "Gana crédito en cada pedido:",
      earnCreditDesc: "Gana crédito con cada pedido y canjéalo por productos.",
      expiry: "Caducidad:",
      expiryDesc: "El crédito caduca tras 45 días sin pedir.",
      expiresIn: "Caduca en %d días",
      expiresInOne: "Caduca en 1 día",
      expiresInToday: "Caduca hoy",
      expired: "Caducado",
      addProductWithWallet: "Añadir producto con Wallet",
      productAddedSuccess: "¡Producto añadido con éxito!",
      productAddedError: "Error al añadir producto. Inténtalo de nuevo.",
      insufficientBalance: "Saldo insuficiente en Wallet",
      addProductSuccess: "Producto añadido al próximo pedido",
      youHaveCredit: "Tienes %s€",
      notEnoughCredit: "No tienes suficiente crédito. Tienes %s€",
      cantUseForSubscriptions: "No puedes usar crédito para suscripciones",
      reactivateToUseWallet:
        "Reactivar suscripción para usar el crédito de la Wallet",
      reactivateDesc:
        "Después de reactivar podrás intercambiar tu crédito por productos.",
    },

    // Orders & Subscription
    orders: {
      deliveredEveryMonth: "· Entregado cada mes",
      lastOrderCharged: "El último pedido se cobró el %s",
      quantity: "Cantidad: %d",
      processingInfo:
        "Estamos procesando tu pedido. El estado se actualizará automáticamente en unos instantes.",
      processingDelayed:
        "El procesamiento de tu pedido está tardando más de lo habitual. Consulta el estado del pedido más tarde.",
    },

    shipping: {
      shippingCost: "%s€ entrega",
      freeShipping: "· Entrega gratuita",
    },

    // User actions
    user: {
      logout: "Cerrar sesión",
      login: "Iniciar sesión",
      profile: "Perfil",
      account: "Cuenta",
      subscription: "Suscripción",
      subscriptionCancelled: "Tu plan está cancelado",
      subscriptionTitle: "Suscripción de",
      reactivate: "Reactivar",
      reactivateAndOrderNow: "Reactivar y pedir ahora",
      reactivateConfirm:
        "Al hacer clic en “OK”, reactivarás tu plan y tramitaremos tu pedido.",
      subscriptionCancelledDesc:
        "Haz clic en “<strong>Reactivar</strong>” para editar o eliminar productos de tu plan. <br> Si quieres recibir tu plan tal cual y pedir ahora, haz clic en “<strong>Reactivar y pedir ahora</strong>”.",
      editProduct: "Editar producto",
      removeProduct: "Eliminar",
      addedWithWallet: "Añadido con wallet",
      confirmDelete:
        "¿Estás seguro de que deseas eliminar este producto de tu plan?",
      cannotRemoveLastProduct:
        "Este es el único producto de la suscripción, por lo que no se puede eliminar.",
    },

    errors: {
      generic: "No pudimos procesar tu pago",
      paymentError: {
        title: "Non siamo riusciti a elaborare il tuo pagamento",
        description:
          "Por favor, actualiza tu método de pago para completar tu pedido.\nSi estás utilizando una tarjeta de un solo uso, prueba con una tarjeta que permita pagos recurrentes.",
        cta: "Actualizar método de pago",
      },
    },
  },
};
